import type { Visualize3dLight } from '../models/visualize3d-light';
import type { Visualize3dComponent } from './visualize3d-component';
import { Visualize3dComponentCreator } from './visualize3d-component-creator';

export interface AmbientLightComponent extends Visualize3dLight, Visualize3dComponent {}

export const ambientLightComponentCreator: Visualize3dComponentCreator<AmbientLightComponent> = {
  createComponent: createAmbientLightComponent,
};

/**
 * Creates new instance of ambient light.
 * Default color '#ffffff'
 * Default intensity 1
 */
export function createAmbientLightComponent(): AmbientLightComponent {
  const light: AmbientLightComponent = {
    color: '#ffffff',
    intensity: 1,
    $type: 'MagiCADCore.Visualize3D.ThreeJS.DataTransfer.AmbientLightDto, MagiCADCore.Visualize3D.ThreeJS',
    type: 'AmbientLight',
  };

  return light;
}
